'use client';

import ErrorPage from '@eliadmin/core/src/pages/error';
import { captureException } from '@sentry/nextjs';
import { useEffect } from 'react';

export default function GlobalError({ error, reset }: any) {
  useEffect(() => {
    captureException(error);
  }, [error]);

  return (
    <html>
      <body>
        <ErrorPage error={error} reset={reset} />
      </body>
    </html>
  );
}
